import React from 'react';
import { useTranslation } from 'react-i18next';

// Internal
// --------

function FooterContent() {
  const { t, ready: translationLoaded } = useTranslation('footer');

  // Render

  if (!translationLoaded) {
    return null;
  }

  const year = new Date().getFullYear();

  return (
    <div className="footer-content">
      <p className="footer-content__copyright">
        Varsity Tutors &copy; 2007-{year}, {t('rightsReserved')}
      </p>
      <ul id="footer-content__links">
        <li>
          <a href={`https://www.${process.env.REACT_APP_DOMAIN_NAME}/guarantee-policy`}>
            {t('legalDisclaimer')}
          </a>
        </li>
        <li>
          <a href={`https://www.${process.env.REACT_APP_DOMAIN_NAME}/privacy`}>
            {t('privacyPolicy')}
          </a>
        </li>
        <li>
          <a href={`https://www.${process.env.REACT_APP_DOMAIN_NAME}/terms-of-use`}>
            {t('termsOfUse')}
          </a>
        </li>
      </ul>
    </div>
  );
}

// Exports
// -------

export default FooterContent;
